import React from 'react';
import { Spin } from 'antd';

interface Props {
  spinning: boolean;
}

export const FullScreenLoaderComponent: React.FC<Props> = (props) => {
  return <Spin spinning={props.spinning} size='large' fullscreen />;
};
